import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class AuxiliarGeneralProvider {

  constructor(public http: HttpClient) {
  }

}



// WEBPACK FOOTER //
// ./src/providers/auxiliar-general/auxiliar-general.ts